import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Step1 from "../../../AnexoContrato/Step1";
import { useState } from "react";
import WhiteButton from "../../../../components/WhiteButton";
import CloseIcon from "@mui/icons-material/Close";
import { alteraContrato } from "../../../../services/api-contratos.service";
import SnackBar from "../../../../components/SnackBar";
import Loading from "../../../../components/Loading";

const ReenvioDeContrato = ({ modal, setModal, idContrato, closePosEnv }) => {
  const [openVisualizador, setOpenVisualizador] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfName, setPdfName] = useState("");
  const [fileKey, setFileKey] = useState(0);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    setModal(false);
    setPdfUrl(null);
    setPdfName("");
    setFileKey(null);
  };

  const handleConvertToBase64 = async (arquivo) => {
    return new Promise((resolve, reject) => {
      fetch(arquivo)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(blob);
        })
        .catch((error) => reject(error));
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const body = {
        idContrato,
        fileName: pdfName,
        base64: await handleConvertToBase64(pdfUrl),
      };

      const response = await alteraContrato(body);
      setObjSnackBar({ type: "success", msg: response.mensagem });

      handleCloseModal();
      closePosEnv();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      setObjSnackBar({ type: "error", msg: error.mensagem });
    }
  };

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  return (
    <>
      <Dialog open={modal} onClose={handleCloseModal} fullWidth maxWidth="md">
        {!loading ? (
          <Step1
            handleCloseModal={handleCloseModal}
            setPdfName={setPdfName}
            setPdfUrl={setPdfUrl}
            pdfUrl={pdfUrl}
            pdfName={pdfName}
            setFileKey={setFileKey}
            setOpenVisualizador={setOpenVisualizador}
            handleAvancar={handleSubmit}
          />
        ) : (
          <Loading loading={loading} />
        )}
      </Dialog>

      {/*Pré-Visualização*/}
      <Dialog
        open={openVisualizador}
        onClose={() => setOpenVisualizador(false)}
        fullWidth
        maxWidth="xl"
      >
        <div style={{ width: "100%", height: "90vh" }}>
          <iframe
            key={fileKey}
            src={pdfUrl}
            title="Pré-visualização do PDF"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
        <DialogActions sx={{ padding: "1rem" }}>
          <WhiteButton
            textValue="Fechar pré-visualização"
            contentIcon={<CloseIcon />}
            clickFunction={() => setOpenVisualizador(false)}
          />
        </DialogActions>
      </Dialog>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default ReenvioDeContrato;
